import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import Pficon from 'components/Pficon';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, Divider, Tooltip } from 'antd';
import questionnaireMessages from 'containers/QuestionnairePage/messages';
import { EDIT_PERMISSIONS, WithPermissions } from 'containers/Permissions';
import { QA_ACTION_TYPES } from 'containers/QuestionnairePage/constants';

const ExclusiveButton = (props) => {
  const {
    isExclusive,
    toggleExclusiveAnswer,
    answerRefId,
    type = QA_ACTION_TYPES.BUTTON,
  } = props;

  const isButtonWithText = type === QA_ACTION_TYPES.BUTTON_WITH_TEXT;

  return (
    <Fragment>
      <WithPermissions permission={EDIT_PERMISSIONS.ANSWER_EXCLUSIVE}>
        {(hasPermission) => {
          const exclusiveIcon = 'exclusive';

          return (
            <Button
              className={classnames(
                'outline-blue',
                'border-none',
                'padding-horizontal-xxs',
                'shadow-none',
                'background-transparent',
                {
                  'color-blue-6-hover': hasPermission,
                  'color-grey-7': !hasPermission && !isExclusive,
                  'color-grey-10': hasPermission && !isExclusive,
                  'background-transparent-hover': !hasPermission,
                  'flex flex-align-items--center flex-justify-center':
                    isButtonWithText,
                },
              )}
              ghost={!hasPermission}
              disabled={!hasPermission}
              onClick={() => toggleExclusiveAnswer(answerRefId)}
            >
              <Tooltip
                placement="bottomRight"
                arrowPointAtCenter
                overlayClassName="tooltip-light"
                trigger={isButtonWithText ? [] : ['hover']}
                title={
                  <FormattedMessage
                    {...(isExclusive
                      ? questionnaireMessages.exclusiveButtonTooltipDeselect
                      : questionnaireMessages.exclusiveButtonTooltip)}
                  />
                }
              >
                <span className="flex flex-items-center">
                  <Pficon
                    className={classnames('text-size-h5', {
                      'color-grey-7': isExclusive && !hasPermission,
                    })}
                    // style={
                    //   isButtonWithText
                    //     ? {
                    //         width: 16,
                    //         textAlign: 'center',
                    //         display: 'inline-block',
                    //       }
                    //     : {}
                    // }
                    size={16}
                    type={exclusiveIcon}
                  />
                  {isButtonWithText && (
                    <span
                      className="margin-left-xxs position-relative"
                      style={{ top: 1 }}
                    >
                      <FormattedMessage
                        {...(isExclusive
                          ? questionnaireMessages.questionAnswerDropdown
                              .unmarkAsExclusive
                          : questionnaireMessages.questionAnswerDropdown
                              .markAsExclusive)}
                      />
                    </span>
                  )}
                </span>
              </Tooltip>
            </Button>
          );
        }}
      </WithPermissions>
      {!isButtonWithText && (
        <Divider
          type="vertical"
          className="margin-horizontal-xs color-grey-5"
        />
      )}
    </Fragment>
  );
};

ExclusiveButton.propTypes = {
  isExclusive: PropTypes.bool.isRequired,
  toggleExclusiveAnswer: PropTypes.func.isRequired,
  answerRefId: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default ExclusiveButton;
